import { StatusPill } from "../../../shared/ui/status-pill";
import { formatCopInput, parseCopInput } from "../model/alertManagementConstants";
import {
  // CalcButton,
  // CalcButtonRow,
  CurrencyInput,
  // ObservationInput,
  ProductName,
  RecalcBanner,
  RecalcHead,
  RecalcRow,
  RecalcSection,
  RecalcTable,
  RecalcTableWrapper,
  // ResultMessage,
} from "./AlertManagementIndeterminateRecalc.styles";

const NEUTRAL_TOKEN = { background: "#F3F4F6", border: "#D1D5DB", color: "#374151" };

// El resultado ya no se calcula en el front: se muestra el valor `resultado`
// que llega del servicio detalle/ (o "---" cuando viene vacío).
const renderResultPill = (resultado) => (
  <StatusPill
    backgroundColor={NEUTRAL_TOKEN.background}
    borderColor={NEUTRAL_TOKEN.border}
    textColor={NEUTRAL_TOKEN.color}
    minHeight="28px"
    padding="4px 12px"
    fontSize="12px"
    fontWeight={800}
    uppercase
  >
    {resultado || "---"}
  </StatusPill>
);

const CURRENCY_FIELDS = [
  { key: "precioMinimo", placeholder: "$ 0" },
  { key: "precioMaximo", placeholder: "$ 0" },
  { key: "valorVentaNuevo", placeholder: "$ 0" },
];

// Campos de rango de precio sujetos a la vigencia de la jornada.
const PRICE_RANGE_FIELDS = new Set(["precioMinimo", "precioMaximo"]);

export const AlertManagementIndeterminateRecalc = ({
  productName,
  resultado,
  canEditPriceRange = false,
  values,
  setField,
  // Campos de observación y cálculo deshabilitados temporalmente:
  // observacion,
  // setObservacion,
  // result,
  // canCalculate,
  // calculate,
}) => {
  // El precio mínimo no puede ser mayor al precio máximo.
  const min = Number(values?.precioMinimo);
  const max = Number(values?.precioMaximo);
  const priceRangeInvalid =
    Number.isFinite(min) && Number.isFinite(max) && min > max;

  // const handleCalculate = () => {
  //   if (!canCalculate) {
  //     AlertComponent.warning(
  //       "Valores incompletos",
  //       "Diligencie los cuatro valores de mercado (precio mínimo, precio máximo, valor unitario venta nuevo y valor catálogo nuevo) para calcular el resultado."
  //     );
  //     return;
  //   }
  //   calculate();
  // };

  return (
    <RecalcSection>
      <RecalcBanner>
        Sub. Operativa completa los valores de mercado, ejecuta el recálculo y visualiza el
        resultado antes de responder sin observación o devolver a subsanación.
      </RecalcBanner>

      <RecalcTableWrapper>
        <RecalcTable>
          <RecalcHead>
            <span>Nuevo producto</span>
            <span>Precio mínimo</span>
            <span>Precio máximo</span>
            <span>Valor unitario venta nuevo</span>
            {/* <span>Observación</span> */}
            <span>Resultado</span>
          </RecalcHead>
          <RecalcRow>
            <ProductName>{productName || "Nuevo producto"}</ProductName>
            {CURRENCY_FIELDS.map(({ key, placeholder }) => (
              <CurrencyInput
                key={key}
                value={values[key] ?? null}
                min={0}
                controls={false}
                disabled={PRICE_RANGE_FIELDS.has(key) && !canEditPriceRange}
                status={PRICE_RANGE_FIELDS.has(key) && priceRangeInvalid ? "error" : undefined}
                placeholder={placeholder}
                formatter={formatCopInput}
                parser={parseCopInput}
                onChange={(next) => setField(key, next)}
              />
            ))}
            {/* <ObservationInput
              value={observacion}
              placeholder="Observación del recálculo"
              maxLength={300}
              onChange={(e) => setObservacion(e.target.value)}
            /> */}
            {renderResultPill(resultado)}
          </RecalcRow>
        </RecalcTable>
      </RecalcTableWrapper>

      {priceRangeInvalid ? (
        <div style={{ color: "#dc2626", fontSize: "0.8rem", fontWeight: 600 }}>
          El precio mínimo no puede ser mayor al precio máximo.
        </div>
      ) : null}

      {/* <CalcButtonRow>
        <CalcButton onClick={handleCalculate}>Calcular resultado</CalcButton>
      </CalcButtonRow>

      {result ? <ResultMessage $tone={result.tone}>{result.message}</ResultMessage> : null} */}
    </RecalcSection>
  );
};